import { render, staticRenderFns } from "./Lps.vue?vue&type=template&id=21d7f574&scoped=true"
import script from "./Lps.vue?vue&type=script&lang=js"
export * from "./Lps.vue?vue&type=script&lang=js"
import style0 from "./Lps.vue?vue&type=style&index=0&id=21d7f574&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d7f574",
  null
  
)

export default component.exports